import { defineStore, storeToRefs } from "pinia"
import { computed, type Ref } from "vue"
import { addShoppingCartItem, deleteShoppingCartItems, fetchShoppingCart, updateQualityOfShoppingCartItem } from "../api"
import type { ShoppingCart, ShoppingCartItem } from "../types"

export const SHOPPING_CART_SERVICE = Symbol.for('SHOPPING_CART_SERVICE')

export interface ShoppingCartService {
  count(): Ref<number>
  fetch(): Promise<Ref<ShoppingCartItem[]>>
  deleteItems(ids: number | number[]): Promise<void>
  updateQualityOfItem(id: number, quality: number): Promise<void>
}

export const useShoppingCart = defineStore(SHOPPING_CART_SERVICE.toString(), {
  state: () => ({
    items: []
  } as ShoppingCart),
  getters: {
    count(state) {
      return state.items.length
    }
  },
  actions: {
    async fetch(): Promise<Ref<ShoppingCartItem[]>> {
      const res: any = await fetchShoppingCart()
      const cart = res.cart
      this.items = cart
      const { items } = storeToRefs(this)
      return items
    },
    async addItem(item: Partial<ShoppingCartItem>): Promise<void> {
      return addShoppingCartItem(item)
    },
    async deleteItems(ids: number | number[]): Promise<void> {
      return deleteShoppingCartItems(ids)
    },
    async updateQualityOfItem(id: number, quality: number): Promise<void> {
      return updateQualityOfShoppingCartItem(id, { quality })
    }
  }
})

export class DefaultShoppingCartService implements ShoppingCartService {

  count(): Ref<number> {
    const cart = useShoppingCart()
    return computed(() => cart.count)
  }

  async fetch(): Promise<Ref<ShoppingCartItem[]>> {
    const cart = useShoppingCart()
    return cart.fetch()
  }

  async deleteItems(ids: number | number[]): Promise<void> {
    const cart = useShoppingCart()
    return cart.deleteItems(ids)
  }

  updateQualityOfItem(id: number, quality: number): Promise<void> {
    const cart = useShoppingCart()
    return cart.updateQualityOfItem(id, quality)
  }
}
